import { QueryClient } from "@tanstack/react-query";

import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { ClusterDto, fetchCluster } from "#modules/cluster/infra/fetchCluster.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const clusterQuery = (id: string | undefined) => ({
  queryKey: queryKeys.clusters.detail(id),
  queryFn: () => fetchCluster(id),
  staleTime: STALE_TIME,
});

export const getClusterQueryData = (
  queryClient: QueryClient,
  id: string,
): ClusterDto | null | undefined => {
  return queryClient.getQueryData<ClusterDto | null>(queryKeys.clusters.detail(id));
};

type ClusterQueryDataUpdater =
  | ClusterDto
  | null
  | undefined
  | ((old: ClusterDto | null | undefined) => ClusterDto | null | undefined);

export const setClusterQueryData = (
  queryClient: QueryClient,
  id: string,
  updater: ClusterQueryDataUpdater,
): ClusterDto | null | undefined => {
  return queryClient.setQueryData<ClusterDto | null>(queryKeys.clusters.detail(id), updater);
};
